(ns practitest.frontend.global-fields-settings.accordion
  (:require
    ["react-bootstrap/Accordion" :as Accordion]
    ["react-bootstrap/AccordionBody" :as AccordionBody]
    ["react-bootstrap/AccordionHeader" :as AccordionHeader]
    ["react-bootstrap/AccordionItem" :as AccordionItem]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.icons :as icons]
    [reagent.core :as re-agent]))

(defn- toggle-view [id open-ids]
  (swap! open-ids
         (fn [open-ids]
           (if (contains? open-ids id)
             (disj open-ids id)
             (conj open-ids id)))))

(defn accordion-list [views-map & [{:keys [start-open?]}]]
  (let [open-ids (re-agent/atom (if start-open? (into #{} (map :id views-map)) #{}))]
    (fn [views-map]
      [:div.accordion-container
       [:> Accordion {:active-key @open-ids}
        (doall
          (for [{:keys [id title body]} views-map]
            (let [open? (contains? @open-ids id)]
              ^{:key id}
               [:> AccordionItem {:event-key id}
                [:> AccordionHeader
                 {:on-click #(toggle-view id open-ids)}
                 (if open?
                   [icons/mux-chevron-down2]
                   [icons/mux-chevron-right])
                 [:span (get-translation "global-field.form-list.title" "Parent value") ":"]
                 [:span.item-name title]]
                [:> AccordionBody
                 (when open?
                   body)]])))]])))